<template>
  <p>
    <label class="checkbox">
      <input type="checkbox" v-model="internalSubscribedToNewsletter">
      Receive by email updates about Bookman
    </label>
  </p>
</template>

<script>
export default {
  name: 'newsletterCheckbox',
  data () {
    return {
      internalSubscribedToNewsletter: false,
      initialized: false
    }
  },
  watch: {
    internalSubscribedToNewsletter (value) {
      if (this.initialized) {
        if (this.internalSubscribedToNewsletter !== this.isSubscribedToNewsletter) {
          this.$store.dispatch('updateSubscribptionToNewsLetter', this.internalSubscribedToNewsletter)
        }
      }
    },
    isSubscribedToNewsletter (value) {
      if (!this.initialized) {
        this.internalSubscribedToNewsletter = this.isSubscribedToNewsletter
        this.initialized = true
      }
    }
  },
  computed: {
    isSubscribedToNewsletter () {
      return this.$store.getters.isSubscribedToNewsletter
    }
  }
}
</script>

<style>

</style>
